// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
const roleHome = {
  customer: "/",
  kitchen: "/kitchen",
  admin: "/index",
  manager:"/dashboard"
};
const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
    console.log("roleProtect",role);
  if (!token) {
    // Not logged in → redirect to login page
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    // Logged in but wrong role → redirect to unauthorized page
     return <Navigate to={roleHome[role] || "/"} />;
  }

  // Allowed → render the page
  return children;
};

export default ProtectedRoute;
